import { generateTokenAuthHeader } from "../../../commonfunctions/authentication";

export interface SliderDetail {
  id: number;
  image: string;
  link: string;
  index: number;
  responsive: boolean;
  activate: boolean;
  slider: number;
}

export interface SliderDetailResponse {
  slider: SliderDetail[];
  slider_responsive: SliderDetail[];
}

const getSliders = async (appBranch: string): Promise<SliderDetailResponse | null> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_HONEYBEE_ROOT_API}/sliders/webstore-${appBranch}`,
      generateTokenAuthHeader(),
    );
    if (res.ok) {
      const data = await res.json();
      return data as SliderDetailResponse;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export default getSliders;
